<template>
<v-row style="max-width: 600px; margin: 0 auto;" >
        
        <v-col id="base" md="12" style="height: 100%; position: relative; display: flex; flex-direction: column;" class="my-0 py-0" >
            <!-- Back button -->
            <v-row justify="start" align="center" style="height:55px; background-color: #e6e6e6;" class="pt-0">
                <v-btn @click="$router.push({ name: 'userprofile'})" icon :color="$store.state.colors.primary">
                    <v-icon x-large >mdi-chevron-left</v-icon>
                </v-btn>
            </v-row>

            <v-row justify="center" align="center" style="color: white" :style="{ 'background-color': $store.state.colors.accent }">
                <v-col class="ml-8 mt-0 pt-1">
                    <v-row >
                        Restauración de contraseña
                    </v-row>
                    <!-- ##### ALERTA FALTA CAMPO ##### -->
                    <!-- <v-snackbar v-model="alert1" class="font" :top="true" color="warning">
                        ¡Falta llenar algún campo!
                    </v-snackbar> -->
                    <!-- <v-snackbar v-model="alert3" class="font" :top="true" color="error">
                        Las contraseñas no coinciden
                    </v-snackbar>  -->
                </v-col>
            </v-row>
            <v-row style="height: 100%;" class="mt-4">
                <v-col class="mb-0 pb-0" >
                        <v-text-field
                            v-model="password"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, rules.minRequeriments]"
                            :type="showPassword ? 'text' : 'password'"
                            :class="{valid:passwordValidation.valid}"
                            name="input-10-1"
                            label="Contraseña"
                            outlined
                            @click:append="showPassword = !showPassword"
                            hide-details
                            class="mb-2"
                        ></v-text-field>
                        <v-text-field
                            v-model="confirPassword"
                            :append-icon="showPass2 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, rules.equals]"
                            :type="showPass2 ? 'text' : 'password'"
                            name="input-10-1"
                            label="Confirma tu contraseña"
                            outlined
                            @click:append="showPass2 = !showPass2"
                            hide-details
                        ></v-text-field>
                    <!-- <v-snackbar :value="alertS" class="font" :top="true" color="success" transition="scale-transition">
                        {{alertMessageS}}
                    </v-snackbar> -->
                    <!-- <v-snackbar v-model="alert" :top="true" color="error">
                        {{alertMessage}}
                    </v-snackbar> -->
                    <!-- <v-snackbar v-model="alert2" :top="true" color="error">
                        {{alertMessage2}}
                    </v-snackbar> -->
                </v-col>
            </v-row>
            <v-row class="pt-1 pl-4 pr-4 pb-0 mb-8 mt-2">
                <transition name="hint" appear>
                    <div v-if='passwordValidation.errors.length > 0 && !submitted' class='font'>
                        <strong>Contraseña que contenga: </strong>
                        <span style="margin: 0; padding: 0" v-for="(error, index) in passwordValidation.errors" :key="index">{{ error }}</span>
                    </div>
                </transition>
            </v-row>
            <v-row justify="center" class="mt-0 mb-0">
                <v-btn :loading="loading" @click="restore()" :class="{'disable-events': !!!password}"  class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 90%; height: 55px; margin: 15px; ">
                    <span style="float: left; padding-left:0px;">Cambiar contraseña</span>
                    <v-spacer></v-spacer>
                    <v-img max-width="20px" src="@/assets/resources/yoomi/arrow_white.png"></v-img>
                </v-btn>
            </v-row>
        </v-col>
</v-row>
</template>

<script>
import axios from 'axios';
    export default {
        name: 'restorePassword',
        data(){
            return {
                loading: false,
                token:'',
                alert: false,
                alert1: false,
                alert2: false,
                alert3: false,
                alertS: false,
                alertMessage: 'Algo sucedió mal, intenta más tarde',
                alertMessage2: 'Cliente no encontrado',
                alertMessageS: 'Contraseña cambiada correctamente',
                alertColor: 'error',
                password: '',
                pass: false,
                confirPassword: '',
                passPattern: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                rules: 
                {
                    equals: c => c ? (c == this.password || 'Las contraseñas no coinciden') : true, 
                    minRequeriments: value => { return value ? (this.passPattern.test(value) || 'Contraseña no válida') : true },
                    required: value => !!value || ''
                },
                showPassword: false,
                showPass2: false,
                showConfirm: false,
                user: null,
                checkPassword:'',
                submitted:false,
                rules2: 
                [
                    { message:'1 Mayúscula, ', regex:/[A-Z]+/  }, 
                    { message:'1 Minúscula, ', regex:/[a-z]+/ }, 
                    { message:'1 Número, ', regex:/[0-9]+/ },
                    { message:"8 Caracteres", regex:/.{8,}/ }, 
                ],
            }
        },
  watch:
  {
      confirmPassword:function()
      {
        if (this.password!=this.confirmPassword) 
        {
            this.alertMessage = "Contraseñas no coinciden";
            this.$store.state.alertState = true;
            this.$store.state.alertMessage = this.alertMessage;
            this.$store.state.alertColor = "error";
            setTimeout(() => {
            this.$store.state.alertState = false;
            }, 4000);
        }
        else{
            this.$store.state.alertState = false; 
        }
        if(this.confirmPassword==''&&this.password=='')
        {
            this.$store.state.alertState = false;
        }
      },
      password:function()
      {
        if(this.confirmPassword!=''&&this.password=='')
        {
          if(this.password!=this.confirmPassword)
          {
            this.alertMessage = "Contraseñas no coinciden";
            this.$store.state.alertState = true;
            this.$store.state.alertMessage = this.alertMessage;
            this.$store.state.alertColor = "error";
            setTimeout(() => {
            this.$store.state.alertState = false;
            }, 4000);
          }
          else{
            this.$store.state.alertState = false;
          }
        }
        if(this.confirmPassword==''&&this.password=='')
        {
            this.$store.state.alertState = false;
        }
      }
  },
        methods:
        {
            resetPasswords () 
            {
                this.password = ''
                this.checkPassword = ''
                this.submitted = true
                setTimeout(() => {this.submitted = false}, 2000)
            },
            async restore ()
            {
                this.loading = true;
                if(this.passwordValidation.errors.length == 0)
                {
                    if((!!this.password && !!this.confirPassword))
                    {
                        if(this.password == this.confirPassword)
                        {
                            var user={
                                contra:this.password,
                            };
                            // console.log(this.token);
                            await axios.post('/reemplazar2', user, {headers: {Authorization: localStorage.getItem("token")}})
                                .then(res =>{
                                    console.log(res);
                                    if(res.data.mensaje == "Contraseña actualizada")
                                    {
                                        this.$store.state.token = res.data.token;
                                        localStorage.setItem("token", res.data.token);
                                        this.$store.state.alertState = true;
                                        this.$store.state.alertMessage = this.alertMessageS;
                                        this.$store.state.alertColor = "success";
                                        setTimeout(() => {
                                            this.$store.state.alertState = false;
                                            this.loading = false;
                                            this.$router.push({ name: 'userprofile'});
                                        }, 4000);
                                    }
                                    else{
                                        this.loading = false;
                                        this.alertMessage = res.data.mensaje;
                                        this.$store.state.alertState = true;
                                        this.$store.state.alertMessage = this.alertMessage;
                                        this.$store.state.alertColor = "error";
                                        setTimeout(() => {
                                        this.$store.state.alertState = false;
                                        }, 4000);
                                    } 
                                })
                                .catch(error => {
                                    console.log(error)
                                    this.loading = false;
                                    this.alertMessage = "Algo sucedió mal, intentalo más tarde";
                                    this.$store.state.alertState = true;
                                    this.$store.state.alertMessage = this.alertMessage;
                                    this.$store.state.alertColor = "error";
                                    setTimeout(() => {
                                    this.$store.state.alertState = false;
                                    }, 4000);
                                    }
                                );
                        }
                        else
                        {
                            this.loading = false;
                            this.$store.state.alertState = true;
                            this.$store.state.alertMessage = "Las contraseñas no coinciden";
                            this.$store.state.alertColor = "error";
                            setTimeout(() => {
                            this.$store.state.alertState = false;
                            }, 4000);
                        }
                    }
                    else
                    {
                        this.loading = false;
                        this.$store.state.alertState = true;
                        this.$store.state.alertMessage = "Falta llenar algún campo";
                        this.$store.state.alertColor = "warning";
                        setTimeout(() => {
                        this.$store.state.alertState = false;
                        }, 4000);
                    }
                }
                else {
                    this.loading = false;
                    this.alertMessage = "La contraseña no es correcta"
                    this.$store.state.alertState = true;
                    this.$store.state.alertMessage = this.alertMessage;
                    this.$store.state.alertColor = "error";
                    setTimeout(() => {
                    this.$store.state.alertState = false;
                    }, 4000);
                }
            }
        },
        computed:
        {
            passwordsFilled () 
            {
                return (this.password !== '' && this.checkPassword !== '')
            },
            passwordValidation () 
            {
                let errors = []
                for (let condition of this.rules2) 
                {
                    if (!condition.regex.test(this.password)) 
                    {
                        errors.push(condition.message)
                    }
                }
                if (errors.length === 0) 
                {
                    return { valid:true, errors }
                } 
                else 
                {
                    return { valid:false, errors }
                }
            }
        }
    }
</script>

<style>

.disable-events 
{
    pointer-events: none;
}
a:hover
{
  background-color: yellow;
}
  
</style>